module.exports = __webpack_public_path__ + "img/autohero-logo.747e7fac.svg";